import makeStyles from '@mui/styles/makeStyles';
import { remCalc } from '@monorepo/shared/src/util/style-util';
import PromptModal from 'components/common/Modals/PromptModal';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';

const altT = (key) => translate('alt', key);

type Props = {
  file: any;
  onAccept: () => void;
  onReject: () => void;
};

const PreviewPhotoModal = ({ file, onAccept, onReject }: Props) => {
  const classes = useStyles();

  return (
    <PromptModal onAccept={onAccept} onReject={onReject}>
      <img
        src={URL.createObjectURL(file)}
        alt={altT('submittedActivity')}
        className={classes.image}
      />
    </PromptModal>
  );
};

export default PreviewPhotoModal;

const useStyles = makeStyles((theme) => ({
  image: {
    maxWidth: '100%',
    maxHeight: '100%',
    borderRadius: remCalc(20),
    marginBottom: remCalc(64),
    [theme.breakpoints.down('md')]: {
      marginBottom: remCalc(48),
    },
    [theme.breakpoints.down('md')]: {
      marginBottom: remCalc(32),
    },
  },
}));

export const PreviewPhotoModalStyles = { boxShadow: 'none' };
